import React, { useState } from 'react';
import './LegalSolutionsShowcase.css';
import signingProfessional from '../../assets/legal-signing-professional.png';

// Colección `solutions` que reúne los elementos utilizados en este flujo.
const solutions = [
  {
    id: 'acciones',
    label: <>Tramita <span>títulos accionarios</span></>,
    metric: '+500 títulos gestionados',
    title: 'Formaliza la participación de tus socios sin complicaciones.',
    description: 'Genera y administra títulos accionarios con un proceso claro, seguro y acompañado por nuestro equipo legal.',
  },
  {
    id: 'poderes',
    label: <>Genera y comparte <span>poderes</span></>,
    metric: '+150 poderes generados',
    title: 'Te ayudamos a generar poderes para tus colaboradores, rápido.',
    description: 'Puedes tramitar un poder para un trabajador, colaborador o socio en cuestión de horas. Elige entre los diferentes poderes disponibles.',
  },
  {
    id: 'consultoria',
    label: <>Agenda una <span>consultoría</span></>,
    metric: '+80 empresas acompañadas',
    title: 'Resuelve tus necesidades corporativas con respaldo especializado.',
    description: 'Agenda una sesión con nuestro equipo para revisar tu caso y definir los siguientes pasos con claridad.',
  },
];

// Componente `LegalSolutionsShowcase` que renderiza esta parte de la interfaz.
export default function LegalSolutionsShowcase() {
  // Estado local `activeSolution` y su actualizador, usados para reflejar cambios en la interfaz.
  const [activeSolution, setActiveSolution] = useState('poderes');
  // Valor intermedio `currentSolution` utilizado por la lógica de este bloque.
  const currentSolution = solutions.find(({ id }) => id === activeSolution) || solutions[1];

  return (
    <section className="legal-solutions-showcase" aria-labelledby="legal-solutions-title">
      <div className="legal-solutions-inner">
        <h2 id="legal-solutions-title">
          Avanza <span>seguro</span>,<br />
          así te ayudamos
        </h2>

        <div className="legal-solutions-grid">
          <nav className="legal-solutions-tabs" aria-label="Soluciones legales">
            {solutions.map((solution) => (
              <button
                key={solution.id}
                type="button"
                className={activeSolution === solution.id ? 'is-active' : ''}
                onClick={() => setActiveSolution(solution.id)}
                aria-pressed={activeSolution === solution.id}
              >
                {solution.label}
              </button>
            ))}
          </nav>

          <div className="legal-solutions-photo-wrap">
            <img
              src={signingProfessional}
              alt="Profesional firmando un documento corporativo"
              className="legal-solutions-photo"
              loading="lazy"
              decoding="async"
            />
          </div>

          <article className="legal-solutions-copy" aria-live="polite">
            <p className="legal-solutions-metric">{currentSolution.metric}</p>
            <h3>{currentSolution.title}</h3>
            <p className="legal-solutions-description">{currentSolution.description}</p>
          </article>
        </div>
      </div>
    </section>
  );
}
